import { render, staticRenderFns } from "./PhoneNumberInsertScreen.vue?vue&type=template&id=bb83e2f8&scoped=true&"
import script from "./PhoneNumberInsertScreen.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberInsertScreen.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberInsertScreen.vue?vue&type=style&index=0&id=bb83e2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb83e2f8",
  null
  
)

export default component.exports